package com.artvending.warden

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.artvending.warden.screens.PageScreen
import com.artvending.warden.screens.PageScreen_
import com.artvending.warden.screens.home.HomeScreenModel
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.dom.addClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.TagElement
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLStyleElement
import org.w3c.dom.events.MouseEvent
import org.w3c.dom.get
import kotlin.js.Date

actual val isWebVersion = true
actual val commonSettings: MySettings by lazy { JsSettings() }
val settings = commonSettings as JsSettings
actual val db: Db by lazy { JsDb() }
actual val httpClient: HttpClient by lazy { JsHttpClient() }
actual val dialog: Dialog by lazy { JsDialog() }
actual val geolocation: GeolocationManager by lazy { JsGeolocationManager() }
val isSensor = window.asDynamic().ontouchstart != null || window.asDynamic().ontouchstart !== undefined
var windowWidth = 0
var scale by mutableStateOf(1.0)
actual val sendingQueue: SendingQueue = JsSendingQueue()


fun onVisibilityChange() {
	val isVisible = js("document.visibilityState === 'visible'") as Boolean
	if (isVisible) {
		//println("Приложение снова в фокусе.")
		// Здесь можно добавить логику, которая должна выполняться при возвращении в фокус.
		if (allowDevice == true)
			launch {
				checkIfNeed()
				
				if (allowDevice == false)
					window.alert(language.DEVICE_NOT_ALLOWED)
			}
	}
}


// Подписываемся на событие изменения видимости
fun addVisibilityListener() {
	//js("document.addEventListener('visibilitychange', onVisibilityChange);")
	document.addEventListener("visibilitychange", { onVisibilityChange() })
}


fun main() {
//
//	val isInside = GeolocationCalculator.isInside(Point(52.293314, 21.002835))
//
//	println("IS_INSIDE = $isInside")
	
	
	//return
	//println(settings.NEW_GUI)
	lockScreenOrientation()
	val style = document.createElement("style") as HTMLStyleElement
	
	fun calculateScale() {
		windowWidth = window.innerWidth
		scale = windowWidth.toDouble() / settings.PAGE_WIDTH
		style.type = "text/css";
		style.innerHTML = "dialog { width: ${(100 / scale).vw}; height: ${(100 / scale).vh}; transformOrigin: top left; transform: scale(${scale}); }";
	}
	
	calculateScale()
	
	window.addEventListener("resize", {
		calculateScale()
	})
	
	log("user = $userPikalkaId")
	document.head?.appendChild(style)
	
	root {
		if (userPikalkaId != "_" && allowDevice != false)
		{
			if (settings.NEW_GUI) {
				PageScreen_()
			}
			else
				PageScreen()
		}
		
		if (allowDevice != false) {
			LaunchedEffect(Any()) {
				val buttons = document.querySelectorAll(".ripple-button")
				
				for (i in 0 until buttons.length) {
					val button = buttons[i]!! as HTMLElement
					log(button)
					
					button.addEventListener("click", { event ->
						val event = event as MouseEvent
						val rect = button.getBoundingClientRect()
						val ripple = button.querySelector("::after")
						val x = event.clientX - rect.left
						val y = event.clientY - rect.top
						
						// Установить позицию волны
						button.style.setProperty("--ripple-x", "${x}px")
						button.style.setProperty("--ripple-y", "${y}px")
						
						// Запустить анимацию
						button.classList.add("ripple")
						window.setTimeout({
							button.removeClass("ripple")
							button.addClass("ripple-end")
							
							// Через некоторое время удаляем и класс "ripple-end", чтобы подготовить кнопку к следующему клику
							window.setTimeout({ button.removeClass("ripple-end") }, 300)
						}, 600)
					});
				}
			}
		}
	}
	
	var dateForReload = today
	
	window.setInterval({
		val newDate = LocalDate.now()
		
		if (newDate != dateForReload)
			reloadPage()
		
		dateForReload = newDate
		
	}, 1000 * 2)
	
	launch {
		try {
			val _userPikalkaId = db.getParameter("user_pikalka_id")
			userId = db.getParameter("user_id", "0").toIntOrNull() ?: 0
			deviceId = db.getParameter("device_id", "1").toIntOrNull() ?: 1
			val languageStr = db.getParameter("language")
			
			when (languageStr) {
				"ukr" -> language = UkrLanguage()
				"pol" -> language = PolLanguage()
				"plt" -> language = PoltLanguage()
			}
			
			avatar = db.getParameter("avatar")
			workingCalendarId = db.getParameter("working_calendar_id").toIntOrNull() ?: 1
			userPikalkaId = _userPikalkaId
		} catch (e: Exception) {
			userPikalkaId = ""
		}
		
		currentScreenModel = HomeScreenModel()
		
		if (userPikalkaId != "" && userPikalkaId != "_") {
			checkDevicePermission()
			
			if (allowDevice == true) {
				getTodayInfo()
				
				val geoResult = geolocation.getGeolocation()
				
				if (geoResult != null && geoResult.errorMessage != "")
					er(geoResult.errorMessage)
				
				if (geoResult?.location == null)
					launch {
						delay(1000)
						showMessage(language.WARNING, language.GEOLOCATION_WARNING)
					}
			}
			else
				window.alert(language.DEVICE_NOT_ALLOWED)
		}
	}
	
	addVisibilityListener()
}


inline fun <T> jsObject(init: T.() -> Unit): T {
	val obj = js("{}")
	init(obj as T)
	return obj
}


actual fun createScanner(): Scanner = JsScanner()


@Composable
fun Column_(attrs: AttrBuilderContext<HTMLDivElement>? = null, content: @Composable () -> Unit) {
	Div({ attrs?.invoke(this); style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column) } }) {
		content()
	}
}


@Composable
fun Row_(attrs: AttrBuilderContext<HTMLDivElement>? = null, content: @Composable () -> Unit) {
	Div({ attrs?.invoke(this); style { display(DisplayStyle.Flex) } }) {
		content()
	}
}


fun CommonColor.toColor() = rgba(r, g, b, a)


fun AttrsScope<HTMLElement>.myOnClick(handler: () -> Unit) {
	if (isSensor)
		this.addEventListener("touchstart") {
			handler()
		}
	else
		onClick {
			handler()
		}
}


external fun confirm(text: String): Boolean


private external val location: Loc


private external interface Loc {
	fun reload(withCache: Boolean)
}


fun reloadPage() {
	location.reload(true)
}


@Composable
fun Card(attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null, content: @Composable () -> Unit) {
	Column_({
		style {
			overflow("hidden")
			borderRadius(12.px)
			alignSelf(AlignSelf.Stretch)
			gap(settings.space)
			backgroundColor(Color.white)
			padding(settings.space)
			property("box-shadow", "0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 4px rgba(0, 0, 0, 0.2)")
		}
		attrs?.invoke(this)
	}) {
		content()
	}
}


@Composable
fun ContainerScope.Card_(content: @Composable () -> Unit) {
	Column(cornerRadius = 12.px, space=settings.space, backgroundColor = Color.white, padding=settings.space, elevation = 4.px) {
		content()
	}
}


enum class ButtonStyle {
	FILLED,
	FILLED_TONAL,
	OUTLINED,
	TEXT
}


@Composable
fun MyButton(buttonStyle: ButtonStyle, myClick: () -> Unit, attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null, content: @Composable () -> Unit) {
	val bbb: (AttrsScope<HTMLButtonElement>.() -> Unit) = {
		if (isSensor)
			addEventListener("touchend") {
				myClick()
			}
		else
			onClick {
				myClick()
			}
		
		attrs?.invoke(this)
	}
	
	TagElement(
		tagName = when (buttonStyle) {
			ButtonStyle.FILLED -> "md-filled-button"
			ButtonStyle.FILLED_TONAL -> "md-filled-tonal-button"
			ButtonStyle.OUTLINED -> "md-outlined-button"
			ButtonStyle.TEXT -> "md-text-button"
		},
		applyAttrs = bbb
	) {
		content()
	}
}


@Composable
fun MyButton(
	myClick: () -> Unit,
	attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	MyButton(ButtonStyle.FILLED, myClick, attrs, content)
}


@Composable
fun TonalButton(
	myClick: () -> Unit,
	attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	MyButton(ButtonStyle.FILLED_TONAL, myClick, attrs, content)
}


@Composable
fun OutlinedButton(
	myClick: () -> Unit,
	attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	MyButton(ButtonStyle.OUTLINED, myClick, attrs, content)
}


@Composable
fun TextButton(
	myClick: () -> Unit,
	attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	MyButton(ButtonStyle.TEXT, myClick, attrs, content)
}


@Composable
fun MdTabs(
	attrs: (AttrsScope<HTMLDivElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	TagElement(tagName = "md-tabs", applyAttrs = attrs) {
		content()
	}
}


@Composable
fun MdPrimaryTab(
	isSelected: Boolean = false,
	attrs: (AttrsScope<HTMLButtonElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	val bbb: (AttrsScope<HTMLButtonElement>.() -> Unit) = {
		if (isSelected)
			attr("active", "")
		
		attrs?.invoke(this)
	}
	TagElement(tagName = "md-primary-tab", applyAttrs = bbb) {
		content()
	}
}


@Composable
fun MdIconButton(
	attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	TagElement(tagName = "md-icon-button", applyAttrs = attrs) {
		content()
	}
}


@Composable
fun MdIcon(
	attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
	content: @Composable () -> Unit,
) {
	TagElement(tagName = "md-icon", applyAttrs = attrs) {
		content()
	}
}


@Composable
fun MdCircularProgress(
	value: Double? = null,
	attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
) {
	val bbb: (AttrsScope<HTMLButtonElement>.() -> Unit) = {
		if (value == null)
			attr("indeterminate", "")
		else
			attr("value", value.toString())
		
		attrs?.invoke(this)
	}
	TagElement(tagName = "md-circular-progress", applyAttrs = bbb) {
	}
}


@Composable
fun MdLinearProgress(
	value: Double? = null,
	attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
) {
	val bbb: (AttrsScope<HTMLButtonElement>.() -> Unit) = {
		if (value == null)
			attr("indeterminate", "")
		else
			attr("value", value.toString())
		
		attrs?.invoke(this)
	}
	TagElement(tagName = "md-linear-progress", applyAttrs = bbb) {
	}
}


fun lockScreenOrientation() {
	try {
		val screen = window.asDynamic().screen
		
		if (screen.orientation != null && screen.orientation.lock != null) {
			screen.orientation.lock("portrait").then(
				{ log("Screen orientation locked to portrait") },
				{ error -> log("Orientation lock failed: $error") }
			)
		}
		else {
			log("Screen Orientation API not supported.")
		}
	} catch (e: Exception) {
		log("Error: $e")
	}
}


actual fun millisecondsToDateTime(millis: Long): LocalDateTime {
	val date = Date(millis)
	
	return LocalDateTime(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0)
}


actual fun showLocationWarning() {
	showMessage(language.WARNING, language.GEOLOCATION_WARNING)
}


actual fun userSetted() {}


actual fun isInternetAvailable() = true


actual fun logError(message: Any) {}


